import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function Layout ({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img src="/logo.png" alt="Inventory" />
          <span className="sidebar-logo-text">Inventory <span className="sidebar-badge">Admin</span></span>
        </div>
        <nav className="sidebar-nav">
          <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`} end>📊 Dashboard</NavLink>
          <NavLink to="/empresas" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>🏢 Empresas</NavLink>
        </nav>
        <div className="sidebar-footer">
          <div className="user-name">{user?.firstName} {user?.lastName}</div>
          <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.45)' }}>System Admin</div>
          <button className="logout-btn" onClick={() => { logout(); navigate('/login') }}>Cerrar sesión →</button>
        </div>
      </aside>
      <main className="main-content">{children}</main>
    </div>
  )
}
